import restClient from "restClient"

export const fetchProjectInvoice = (orgId: Number, projectId: Number): Promise<any> => {
    const restClientInstance = restClient(window.API_ROOT + '/api')
    return restClientInstance('CUSTOM_GET', 'custom', {
        url: `orgs/${orgId}/invoices/project_settings/${projectId}/`,
    }).then((res) => {
        return res.data
    })
}